import c from "./lib/createApi";

export default {
  gets: c("GET", "/v1/field", true), // [분야 - 1] 분야 불러오기
  findCommitteeField: c("GET", "/v1/field/findCommitteeField", true), // [분야 - 2] 전문위원 간사신청 분야 불러오기
};
